import React from 'react'
import toast from 'react-hot-toast'
import { ConfirmationModal } from '../ui'

// Confirmation dialog for withdrawing from / declining a deal. Shared by carbon
// and ppa; the per-app withdraw call is injected via `onWithdraw` (each app's
// useDealsService().withdrawFromDeal) so the modal stays free of app services.
export interface ConfirmWithdrawModalProps<T extends { id: string }> {
  withdrawnDeal: T | null
  // Each app's useDealsService().withdrawFromDeal (returns Promise<unknown>).
  onWithdraw: (dealId: string) => Promise<unknown> | void
  onAfterWithdrawn?: () => void
  withdrawalMessage: (deal: T) => React.ReactNode
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- matches Modal's polymorphic isOpen pattern
  isOpen: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setIsOpen: (value: any) => void
}

function ConfirmWithdrawModal<T extends { id: string }> ({
  withdrawnDeal,
  onWithdraw,
  onAfterWithdrawn,
  withdrawalMessage,
  isOpen,
  setIsOpen,
}: ConfirmWithdrawModalProps<T>) {
  const doWithdraw = async () => {
    if (!withdrawnDeal) return
    setIsOpen(false)
    toast.success('You have withdrawn from the deal. Deal moved to portfolio')
    onAfterWithdrawn?.()
    await onWithdraw(withdrawnDeal.id)
  }

  return (
    <ConfirmationModal
      isOpen={!!isOpen}
      setIsOpen={setIsOpen}
      title="Not interested?"
      message={<>{withdrawnDeal ? withdrawalMessage(withdrawnDeal) : null}</>}
      confirmLabel="Withdraw"
      onConfirm={doWithdraw}
      variant="danger"
    />
  )
}

export default ConfirmWithdrawModal
